import Model from '@/models/Model'

export default class HrCompensationFund extends Model {
    resource() {
        return 'hr_compensation_fund'
    }

    toCreate () {
      return this.clean([
        'hr_previred_compensation_fund_id'
      ])
    }
}